import { cn } from "../../../lib/utils";
import { DAY_TYPE_OPTIONS } from "../constants/scheduleConfig";

/**
 * DayTypeSelector
 *
 * Hardcoded 3-way pill selector: Full Day / Half Day / Holiday.
 * Maps directly to org_weekly_work_schedule.day_type
 * ('FULL_DAY' | 'HALF_DAY' | 'HOLIDAY').
 *
 * Props:
 * - value: "FULL_DAY" | "HALF_DAY" | "HOLIDAY"
 * - onChange: (nextType: string) => void
 * - disabled: boolean (optional)
 */
export function DayTypeSelector({ value, onChange, disabled = false }) {
  return (
    <div className="inline-flex flex-wrap gap-2">
      {DAY_TYPE_OPTIONS.map((option) => {
        const isSelected = value === option.value;
        return (
          <button
            key={option.value}
            type="button"
            disabled={disabled}
            onClick={() => onChange(option.value)}
            className={cn(
              "h-9 px-3.5 inline-flex items-center gap-1.5 rounded-xl border text-xs font-semibold transition whitespace-nowrap",
              "disabled:opacity-50 disabled:cursor-not-allowed",
              isSelected
                ? "border-[var(--color-primary)] bg-[var(--color-primary)]/5 text-[var(--color-primary)]"
                : "border-[var(--color-text-border)] bg-white text-[var(--color-text-secondary)] hover:text-foreground"
            )}
          >
            <span
              className={cn(
                "h-1.5 w-1.5 rounded-full",
                isSelected ? "bg-[var(--color-primary)]" : "bg-[var(--color-text-secondary)]/40"
              )}
            />
            {option.label}
          </button>
        );
      })}
    </div>
  );
}